// extracted by mini-css-extract-plugin
module.exports = {"content":"PageContent_content__3h_RV","isLast":"PageContent_isLast__1K04x","techs":"PageContent_techs__3D42O","techText":"PageContent_techText__1dMG3"};